import type { AgencyPortfolioSummaryV1 } from "@enrein/shared-contracts";
import type { V10Navigate } from "../routing/v10-routing.js";

export function V10PortfolioView({
  summary,
  loading,
  error,
  onNavigate,
}: {
  readonly summary: AgencyPortfolioSummaryV1 | null;
  readonly loading: boolean;
  readonly error: string | null;
  readonly onNavigate: V10Navigate;
}) {
  if (loading) {
    return (
      <section className="v10-panel" aria-busy="true" data-testid="v10-portfolio-view">
        <h2>Portfolio</h2>
        <p className="v10-muted">Loading launched sites, health, and client requests…</p>
      </section>
    );
  }
  if (error) {
    return (
      <section className="v10-panel" data-testid="v10-portfolio-view">
        <h2>Portfolio</h2>
        <p className="v10-error">{error}</p>
      </section>
    );
  }
  const data = summary;
  return (
    <section className="v10-panel" data-testid="v10-portfolio-view">
      <header className="v10-panel__header">
        <h2>Portfolio</h2>
        <p className="v10-muted">
          Launched sites, health signals, open client requests, and modernization opportunities.
        </p>
      </header>
      <div className="v10-portfolio-stats" role="list">
        <div role="listitem">
          <span className="v10-stat-label">Launched sites</span>
          <strong>{data?.launchedSiteCount ?? 0}</strong>
        </div>
        <div role="listitem">
          <span className="v10-stat-label">Health attention</span>
          <strong>{data?.attentionHealthCount ?? 0}</strong>
        </div>
        <div role="listitem">
          <span className="v10-stat-label">Open requests</span>
          <strong>{data?.openRequestCount ?? 0}</strong>
        </div>
        <div role="listitem">
          <span className="v10-stat-label">Modernization</span>
          <strong>{data?.modernizationOpportunityCount ?? 0}</strong>
        </div>
      </div>
      <table className="v10-table">
        <thead>
          <tr>
            <th scope="col">Business</th>
            <th scope="col">Launch</th>
            <th scope="col">Health</th>
            <th scope="col">Requests</th>
            <th scope="col">Opportunities</th>
          </tr>
        </thead>
        <tbody>
          {(data?.items ?? []).map((item) => (
            <tr key={item.projectId}>
              <td>
                <button
                  type="button"
                  className="v10-link-btn"
                  onClick={() => onNavigate({ view: "project", projectId: item.projectId, section: null })}
                >
                  {item.businessName}
                </button>
              </td>
              <td>{item.launchStatus}</td>
              <td>{item.siteHealth}</td>
              <td>{item.openClientRequests}</td>
              <td>{item.modernizationOpportunities}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {(data?.items.length ?? 0) === 0 ? (
        <p className="v10-muted">No launched portfolio items yet — complete a launch to populate this view.</p>
      ) : null}
    </section>
  );
}
